import {SET_UPDATING_ASSESSMENTS} from '../_CONSTANTS';

export const setUpdatingAssessments = (bool) => {
  return {
    type: SET_UPDATING_ASSESSMENTS,
    payload: bool
  }
}
